import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import {
  CheckboxInput,
  FormContainer,
  NextButton,
  Option,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";

type Values = {
  initialTreatmentTags: string[];
};

export const MoreTreatmentDetailsPage: FC = () => {
  const { t } = useTranslation();
  const { initialTreatmentTags } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  // `value`s are stable backend keys (stored as treatment_history tags); only
  // the labels are localized.
  const options: Option[] = [
    {
      text: t("onboarding.moreTreatmentDetailsPage.options.donorSperm"),
      value: "donor sperm",
    },
    {
      text: t("onboarding.moreTreatmentDetailsPage.options.sameSexCouple"),
      value: "same sex couple",
    },
    {
      text: t("onboarding.moreTreatmentDetailsPage.options.havePartner"),
      value: "I have a partner in this journey",
    },
    {
      text: t("onboarding.moreTreatmentDetailsPage.options.independent"),
      value: "I'm doing this independently",
    },
  ];

  // This question is optional — the member may continue without selecting any
  // option, so there is no validation schema.
  const initialValues: Values = {
    initialTreatmentTags: initialTreatmentTags || [],
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.moreTreatmentDetailsPage.question")} />

          <CheckboxInput
            defaultValue={initialValues.initialTreatmentTags}
            id="initialTreatmentTags"
            options={options}
          />
        </QuestionContainer>

        <NextButton />
      </FormContainer>
    </QuestionPageContainer>
  );
};
